import { render, staticRenderFns } from "./innerGrowUpList.vue?vue&type=template&id=a0ba5282&scoped=true"
import script from "./innerGrowUpList.vue?vue&type=script&lang=js"
export * from "./innerGrowUpList.vue?vue&type=script&lang=js"
import style0 from "./innerGrowUpList.vue?vue&type=style&index=0&id=a0ba5282&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba5282",
  null
  
)

export default component.exports